





















































































import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex';
export default Vue.extend({
  data() {
    return {
      methods: ['password'] as string[],
      email: {
        class: "",
        help: "",
        value: ""
      },
      password: {
        class: "",
        help: "",
        value: ""
      },
      loading: false
    }
  },
  computed: {
    ...mapState([
      "auth"
    ]),
    title() {
      return process.env.VUE_APP_TITLE
    }
  },
  methods: {
    getSignInMethods() {
      this.$auth.fetchSignInMethodsForEmail(this.email.value).then(methods => {
        this.methods = methods
        this.$store.dispatch('auth/setMethods', methods)
        if (methods.indexOf('password') > -1) {
          const focusPassword = setInterval(() => {
            const passwordInput = document.getElementById('password-input')
            if (passwordInput) {
              passwordInput.focus()
              clearInterval(focusPassword)
            }
          }, 50)
        }
      }).catch(error => {
        alert(error.message)
      })
    },
    async signIn(method:string) {
      this.loading = true
      const provider = (key:string) => {
        if (key == 'google.com') {
          //@ts-ignore
          return new this.$firebase.auth.GoogleAuthProvider()
        } else if (key == 'microsoft.com') {
          //@ts-ignore
          return new this.$firebase.auth.OAuthProvider('microsoft.com')
        }
      }

      let email = this.email.value
      
      switch(method) {
        case 'password':
          if (email.indexOf('@') === -1 || email.indexOf('.') === -1) {
           const authUrl = process.env.VUE_APP_API_AUTH

            try {
              const getEmail = await axios({
                url: authUrl,
                method: "POST",
                data: {username: email}
              })
              email = getEmail.data
            } catch (err) {
              alert(err.message + ": Invalid Username")
              this.loading = false
              break
            }
          }

          if (email) {
            this.$auth.signInWithEmailAndPassword(email, this.password.value)
            .catch(error => {
              alert(error.message)
              this.loading = false
            })
            break
          } else {
            alert("Invalid username or email address.")
            this.loading = false
            break
          }
          
        default:
          this.$auth.signInWithPopup(provider(method))
          .catch(error => {
            alert(error.message)
            this.loading = false
          })
          break
      }
    }
  }
})
